document.querySelectorAll(".animated-bg__item").forEach((el) => {
    const duration = el.dataset.animationDuration;
    const x = el.dataset.animationX;
    const y = el.dataset.animationY;
    const reverse = el.dataset.animationReverse;

    el.style.animationDuration = duration ? duration : "5s";
    el.style.left = x ? `${x}%` : "0";
    el.style.top = y ? `${y}%` : "0";

    if (reverse) {
        el.style.animationDirection = "alternate-reverse";
    };
});